(function () {
  if (window.__inclusionsScriptLoaded) {
    console.warn('🛑 inclusions-v2.js already loaded, skipping...');
    return;
  }
  window.__inclusionsScriptLoaded = true;
  console.log('✅ inclusions-v2.js loaded');
})();

$(()=>{
  const extraInclusionPrice = window.HM?.extraInclusionFee || 0;
  const engravingPrice = window.HM?.engravingFee || 0;

  let totalExtraInclusions = 0;
  let chargeEngravingFee = false;
  let manuallyEdited = new Set();

  function applyEngravingDefaults(stoneCount, force = false) {
    // Clear manual tracking for removed stones
    manuallyEdited = new Set([...manuallyEdited].filter(slot => {
      const idx = slot.charCodeAt(0) - 65;
      return idx < stoneCount;
    }));
    
    let hasCustomEngraving = false;
  
    for (let i = 0; i < stoneCount; i++) {
      const suffix = String.fromCharCode(65 + i); // A, B, C...
      const val = $(`#engraving-select-${suffix}`).val();
      if (val === 'Custom') {
        hasCustomEngraving = true;
        break;
      }
    }
  
    for (let i = 0; i < stoneCount; i++) {
      const suffix = String.fromCharCode(65 + i);
      const $engravingSelect = $(`#engraving-select-${suffix}`);
    
      // Skip override if user has manually changed this dropdown
      if (!force && manuallyEdited.has(suffix)) continue;
    
      const isOdd = stoneCount % 2 !== 0;
      const isCenter = isOdd && i === Math.floor(stoneCount / 2);
      const isFirst = !isOdd && i === 0;
    
      const useLogo = isCenter || isFirst;
    
      // Define valid options
      const options = useLogo ? ['HM Logo', 'Custom'] : ['None', 'Custom'];
    
      // Clear existing options and repopulate
      $engravingSelect.empty();
      options.forEach(opt => {
        $engravingSelect.append(`<option value="${opt}">${opt}</option>`);
      });
    
      // Apply default selection
      $engravingSelect.val(useLogo ? 'HM Logo' : 'None');
    }
  }
  
  // Track manual engraving selections
  $(document).on('change', '.engraving-select', function () {
    const slot = $(this).attr('id').split('engraving-select-')[1];
    manuallyEdited.add(slot);
  });

  function resetEngravingDefaultForSlot(suffix, stoneCount) {
    // suffix = 'A'|'B'|'C'...  stoneCount = current visible stones
    const i = suffix.charCodeAt(0) - 65; // 0-based index
    const $engravingSelect = $(`#engraving-select-${suffix}`);
    if (!$engravingSelect.length) return;

    const isOdd = stoneCount % 2 !== 0;
    const isCenter = isOdd && i === Math.floor(stoneCount / 2);
    const isFirst = !isOdd && i === 0;

    const useLogo = isCenter || isFirst; // center for odd, first for even
    const options = useLogo ? ['HM Logo', 'Custom'] : ['None', 'Custom'];

    // re-populate choices and set default
    $engravingSelect.empty();
    options.forEach(opt => $engravingSelect.append(`<option value="${opt}">${opt}</option>`));
    $engravingSelect.val(useLogo ? 'HM Logo' : 'None').trigger('change');
  }


  
  // Run default logic on page load (assuming 1 stone)
  $(document).ready(function () {
    applyEngravingDefaults(1);
  });
  
  // Also run on stone count change
  $('#stone-count-select').on('change', function () {
    const newCount = parseInt($(this).val(), 10) || 1;
    applyEngravingDefaults(newCount);
  });


  $('#stone-count-select').on('change', function () {
    const count = parseInt($(this).val(), 10);
    const letters = ['A', 'B', 'C', 'D', 'E'];
  
    letters.forEach((letter, idx) => {
      const $inclusionBlock = $(`.inclusions[data-inclusions="${letter}"]`);
      $inclusionBlock.toggle(idx < count);
    });
  }).trigger('change'); // Ensure it loads correctly by default

  $('.check-item').on('click', function (e) {
    const $input = $(this).find('input[type="checkbox"]');
    $input.prop('checked', !$input.prop('checked')).trigger('change');
  });

  $('.engraving-select').on('change', function () {
    const selected = $(this).val();
    const slot = $(this).attr('id').split('engraving-select-')[1];
    const $textWrap = $(`.engraving-text-wrap[data-item="engraving_text_${slot}"]`);

    if (selected === 'Custom') {
      $textWrap.removeClass('hidden');
    } else {
      $textWrap.addClass('hidden');
      $textWrap.find('.engraving-text-input').val('');
      $textWrap.find('.engraving-char-count').text(`0 / ${$textWrap.find('.engraving-text-input').attr('maxlength')}`);
    }
  });

  $('[data-item="optional"] input[type="checkbox"]').on('change', function () {
    const $container = $(this).closest('.select__wrap[data-item="optional"]');
    const suffix = $container.data('suffix');
    const isNoAdd = $(this).hasClass('no-add');
  
    if (isNoAdd && $(this).is(':checked')) {
      $container.find('input[type="checkbox"]:not(.no-add)').prop('checked', false);
    } else {
      $container.find('input[type="checkbox"].no-add').prop('checked', false);
    }
  
    const selectedAddons = [];
    $container.find('input[type="checkbox"]:checked').each(function () {
      selectedAddons.push($(this).val());
    });
  
    // ✅ Update title h6 text
    const titleText = selectedAddons.length > 0
      ? selectedAddons.join(', ').toUpperCase()
      : 'Free Add-On (Optional)';
    $container.find('.select-item-name h6').text(titleText);
  
    // ✅ Toggle .active for border styling
    $container.toggleClass('active', selectedAddons.length > 0);
  });

  $('.engraving-text-input').on('input', function () {
    const slot = $(this).data('slot');
    const length = $(this).val().length;
    const max = $(this).attr('maxlength');
    $(`.engraving-char-count[data-slot="${slot}"]`).text(`${length} / ${max}`);
  });

  // Toggles the 'active' class on the inclusion checkbox container whenever a select wrapper is clicked
  $('.inclusion__checkboxs .select__wrap .select-item-name').on('click', function (e) {
    e.stopPropagation(); // prevent bubbling to other dropdowns
  
    const $parentWrap = $(this).closest('.select__wrap');
    const $checkboxWrapper = $parentWrap.find('.select-checkbox');
  
    // Close any other open ones inside the same inclusion block
    $parentWrap.siblings('.select__wrap').find('.select-checkbox').removeClass('active');
  
    $checkboxWrapper.toggleClass('active');
  });

  // === Three-stone checkbox logic: up to 2 items per stone; "birthstone" is exclusive ===

// Helpers
function showBirthstoneUI(suffix, show) {
  const $container = $(`.birthstone-container[data-birthstone-for="${suffix}"]`);
  $container.toggleClass('hidden', !show);

  // Add/remove required on the real <select> if present
  const $month = $(`#birthstone-select-${suffix}`);
  if ($month.length) {
    $month.toggleClass('req_input', show);
    if (!show) $month.val('');
  }
}

function resetOptionalForSuffix(suffix) {
  const $optWrap = $(`.select__wrap[data-item="optional"][data-suffix="${suffix}"]`);
  if ($optWrap.length === 0) return;

  // Reset selections to "no add on’s"
  const $noAdd = $optWrap.find('input.no-add');
  $optWrap.find('input[type="checkbox"]').prop('checked', false);
  if ($noAdd.length) $noAdd.prop('checked', true);

  // Reset header text
  $optWrap.find('.select-item-name h6').text("Choose Your Addon's");
}

function toggleOptionalVisibility(suffix, show) {
  const $optBlock = $(`.select__wrap[data-item="optional"][data-suffix="${suffix}"]`).closest('.inclusion__contant');
  if ($optBlock.length) $optBlock.toggleClass('hidden', !show);
}

function toggleAshesUI(suffix, show) {
  const $ashes = $(`.select__wrap[data-item="ashes"][data-suffix="${suffix}"]`);
  if ($ashes.length) {
    $ashes.toggleClass('hidden', !show);
    if (!show) $(`#ashes-select-${suffix}`).val('');
  }
}

function toggleOtherUI(suffix, show) {
  const $other = $(`.select__wrap[data-item="other"][data-suffix="${suffix}"]`);
  if ($other.length) {
    $other.toggleClass('hidden', !show);
    if (!show) $(`#other_inclusion-${suffix}-text`).val('');
  }
}

function updateInclusionsHeader($wrap) {
  const picked = $wrap.find('input[name="inclusion"]:checked').map(function () {
    return String(this.value).toUpperCase();
  }).get();
  const title = picked.length ? picked.join(', ') : 'Choose your Inclusions';
  $wrap.find('.select-item-name h6').text(title);
}

// Main delegated handler for checkbox inclusions
$(document).on('change', '.inclusion__checkboxs input[name="inclusion"]', function () {
  const $wrap = $(this).closest('.select__wrap[data-item="inclusions"]');
  const suffix = String($wrap.data('suffix') || '').toUpperCase();   // A, B, C
  const max = parseInt($wrap.data('max'), 10) || 2;
  const val = String($(this).val() || '').toLowerCase();

  const $all = $wrap.find('input[name="inclusion"]');
  const $birthstone = $all.filter(function () { return String(this.value).toLowerCase() === 'birthstone'; });

  // If they clicked "birthstone"
  if (val === 'birthstone') {
    if (this.checked) {
      // Exclusive: uncheck everything else, disable them while active
      $all.not(this).prop('checked', false).prop('disabled', true);

      // Show month dropdown, hide optional and other dependent bits
      showBirthstoneUI(suffix, true);
      toggleOptionalVisibility(suffix, false);
      resetOptionalForSuffix(suffix);
      toggleAshesUI(suffix, false);
      toggleOtherUI(suffix, false);
    } else {
      // Leaving birthstone: re-enable other options, hide month
      $all.prop('disabled', false);
      showBirthstoneUI(suffix, false);
      // Optional block visible again by default
      toggleOptionalVisibility(suffix, true);
    }
    updateInclusionsHeader($wrap);
    return;
  }

  // Non-birthstone path
  // If birthstone is checked, uncheck it and re-enable others
  if ($birthstone.is(':checked')) {
    $birthstone.prop('checked', false);
    $all.prop('disabled', false);
    showBirthstoneUI(suffix, false);
  }

  // Enforce max number of non-birthstone selections
  const nonBirthChecked = $wrap.find('input[name="inclusion"]:checked').filter(function () {
    return String(this.value).toLowerCase() !== 'birthstone';
  });

  if (nonBirthChecked.length > max) {
    // Undo this selection and bail
    $(this).prop('checked', false);
    updateInclusionsHeader($wrap);
    return;
  }

  // Toggle dependent UI for 'ashes' and 'other'
  const chosenValues = nonBirthChecked.map(function () { return String(this.value).toLowerCase(); }).get();

  toggleAshesUI(suffix, chosenValues.includes('ashes'));
  toggleOtherUI(suffix, chosenValues.includes('other'));

  // Optional free add-ons stay visible for non-birthstone flow
  toggleOptionalVisibility(suffix, true);

  updateInclusionsHeader($wrap);
});

// Also open/close the faux dropdown on header click, matching your UI
$(document).on('click', '.select-item-name', function (e) {
  e.stopPropagation();
  $(this).closest('.select-checkbox').toggleClass('active');
});
$(document).on('mouseup', function (e) {
  $('.select-checkbox').each(function () {
    const $box = $(this);
    if (!$box.is(e.target) && $box.has(e.target).length === 0) {
      $box.removeClass('active');
    }
  });
});

// Optional: when page loads, ensure birthstone-only stones (A/C when flagged)
// are shown correctly if you pre-render a hidden input as "birthstone".
$(function () {
  $('.inclusion__contant.birthstone-only').each(function () {
    const suffix = String($(this).closest('.inclusions').data('inclusions') || '').toUpperCase();
    showBirthstoneUI(suffix, true);
    toggleOptionalVisibility(suffix, false);
    toggleAshesUI(suffix, false);
    toggleOtherUI(suffix, false);
  });
});


  // Accordion toggle for inclusion sections.
$('.inclusion__body.inclusion__variant')
  .off('.accordion') // clear any prior namespaced binds if you used one
  .on('click.accordion', function (e) {
    // 🚫 Do nothing if the click came from the design dropdown
    if ($(e.target).closest('.custom__select').length) return;

    const $clicked = $(this);

    // Close all others
    $('.inclusion__body.inclusion__variant').not($clicked).removeClass('active');

    // Toggle this one
    $clicked.toggleClass('active');

    // Scroll just a bit after layout shift
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const offset = 130;
        const y = $clicked.offset().top - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    // Reveal birthstone field if this one is active
    const suffix = $clicked.closest('.inclusions').data('inclusions');
    const birthstoneWrap = $(`.birthstone__wrap[data-item="birthstone-${suffix}"]`);
    if ($clicked.hasClass('active') && birthstoneWrap.length) {
      birthstoneWrap.removeClass('hidden');
    }
  });


  /**
   * Generates a random 7-character alphanumeric string (letters and digits).
   * Used to create a unique identifier (id-product) for each custom product configuration,
   * ensuring that customized products are treated as distinct line items in the cart.
   */
  
  function indexGeneral(){
    let arr_nun = [0 ,1,2,3,4,5,6,7,8,9];
    let arr_en = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    let arr_EN = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    let mass = [...arr_en, ...arr_EN,...arr_nun];
    let index = [];
        
    for(let i = 0; i <= 6; i++){
      let el = mass[Math.floor(Math.random() * mass.length)];
      index.push(el);
    }
        
    return index.join(''); 
   }

  // Prevent clicks inside these elements from bubbling up and unintentionally closing the accordion or dropdown
  $('.birthstone__wrap, .select__wrap, .inclusion__contant, .engraving-options-block').on('click', function (e) {
    // let the custom design select bubble to the document handler
    if ($(e.target).closest('.custom__select').length) return;
    e.stopPropagation();
  });

  // -----------------------------------------------------------------------------
  // validLineItem()
  // Validates required input fields before allowing the product to be added to cart.
  // - Checks all inputs with the `.req_input` class.
  // - If a field is empty, highlights its wrapper with a red border.
  // - If filled, resets the border to white.
  // - Toggles the `.disable` class on the submit button based on overall validity.
  // - Expands inclusion accordion sections to show validation feedback.
  // - Sets the global `valid` flag used in the add-to-cart logic.
  // -----------------------------------------------------------------------------
  function validLineItem() {
    let isValid = true;
    let inclusionValid = true;
    let firstInvalidTextInput = null;

    console.log('🔍 Running validation...');

    // Clear previous visual errors
    $('.input_wrap').css('border', '1px solid #fff');
    $('.inclusions[data-inclusions]').removeClass('error');

    // 1. Validate inclusion blocks FIRST (visible only)
    $('.inclusions[data-inclusions]:visible').each(function () {
      const suffix = $(this).data('inclusions');
      const $select = $(`#inclusion-select-${suffix}`);
      const $checkboxes = $(`.select__wrap[data-item="inclusions"][data-suffix="${suffix}"] input[type="checkbox"]`);

      const hasSelect = $select.length && $select.val();
      const hasCheckbox = $checkboxes.length && $checkboxes.is(':checked');

      if (!hasSelect && !hasCheckbox) {
        $(this).addClass('error');
        inclusionValid = false;
        isValid = false;
      }
    });

    // 2. Show inclusion-related UI if needed
    if (!inclusionValid) {
      $('.my-product-form__submit').addClass('disable');
      $('.inclusions[data-inclusions] .inclusion__body').addClass('active');
      valid = false;
      alert('Please select at least one inclusion for each stone.');
      return; // stop here — inclusion is priority
    }

    // 3. If inclusions are valid, validate text inputs
    $('.req_input:visible:not(:disabled)').each(function () {
      const value = $(this).val();

      // Safely handle null or undefined values
      if (value == null || String(value).trim() === '') {
        $(this).closest('.input_wrap').css('border', '1px solid #B53E2E');

        if (!firstInvalidTextInput) {
          firstInvalidTextInput = this;
        }

        isValid = false;
      }
    });


    // 4. Focus first invalid dedication input (if present)
    if (firstInvalidTextInput) {
      const $accordion = $(firstInvalidTextInput).closest('.inclusion__body');
      $accordion.addClass('active');

      setTimeout(() => {
        firstInvalidTextInput.focus();
      }, 100);
    }

    // 5. Update button state and global flag
    $('.my-product-form__submit').toggleClass('disable', !isValid);
    valid = isValid;
    
    console.log (inclusionValid);
    console.log (isValid);
    // Show helpful message for user
    if (!inclusionValid) {
      alert('Please select at least one inclusion for each visible stone.');
    } else if (!isValid) {
      alert('Please complete all required dedication fields.');
    }
  }

  /**
   * handleResponse()
   * Callback for the XMLHttpRequest 'load' event.
   * Parses the response from Shopify's section rendering API and updates the UI:
   * - Replaces the cart icon bubble with the updated version.
   * - Replaces the contents of the cart drawer using the returned HTML.
   * Ensures that cart visual elements reflect the most recent cart state after an item is added.
   */
  function handleResponse() {
    let a = this.responseText;
    let parser = new DOMParser();
    let objCarts = JSON.parse(this.responseText);
    $('#cart-icon-bubble').html($(objCarts["cart-icon-bubble"]).html());
    $('cart-drawer').html($(objCarts["cart-drawer"]).find('cart-drawer').html());
  }

$(document)
  .off('click.hmATC', '.product .my-product-form__submit')
  .on('click.hmATC', '.product .my-product-form__submit', function (e) {

    e.preventDefault();
    validLineItem();

    const quantity = parseInt($('.quantity__input').val(), 10);
    const variantId = $('input[name="id"]').val();
    const idProduct = indexGeneral();
    const stoneCount = parseInt($('#stone-count-select').val(), 10) || 1;

    // Line item properties
    const properties = {
      'Size': $('.propert-size').find('input').val(),
      'Created for': $('#your-create').val(),
      'In Honor of': $('#your-honor').val(),
      'id-product': idProduct,
    };

    // Dynamically add custom property fields with prop-name attribute
    $('.my-custom-property').each(function () {
      const propName = $(this).attr('prop-name');
      const value = $(this).val();
      if (propName && value) {
        properties[propName] = value;
      }
    });

    let totalExtraInclusions = 0;
    let chargeEngravingFee = false;

    $('.inclusions[data-inclusions]').each(function () {
      const $slot = $(this);
      if (!$slot.is(':visible')) return;

      const suffixRaw = $slot.data('inclusions');
      if (!suffixRaw) return; // ✅ skip blanks

      const suffix = String($slot.data('inclusions')).toUpperCase();
      console.log(`🎯 running inclusion logic for ${suffix}`);
      let inclusions = '';

      // Get inclusions (checkbox or select)
      const $checkboxInclusions = $(`.select__wrap[data-item="inclusions"][data-suffix="${suffix}"] input[type="checkbox"]:checked`);
      if ($checkboxInclusions.length) {
        inclusions = $checkboxInclusions.map(function () {
          return $(this).val();
        }).get().join(', ');
      } else {
        const selectVal = $(`#inclusion-select-${suffix}`).val();
        if (selectVal) {
          inclusions = selectVal;
        }
      }

      if (inclusions) {
        properties[`Inclusions ${suffix}`] = inclusions;
        const inclusionList = inclusions.split(',').map(i => i.trim()).filter(i => i.length > 0);
        const count = inclusionList.length;
        const extras = Math.max(0, count - 1);
        if (extras > 0) {
          totalExtraInclusions += extras;
          properties[`Extra Inclusions ${suffix}`] = `${extras} x $${window.HM.extraInclusionFee}`;
        }
      }

      // Optional Add-ons
      const optional = $(`.select__wrap[data-item="optional"][data-suffix="${suffix}"] input[type="checkbox"]:checked`)
        .map(function () {
          return $(this).val();
        }).get().join(', ');
      if (optional) properties[`Optional ${suffix}`] = optional;

      // Ashes
      const ashes = $(`#ashes-select-${suffix}`).val();
      if (ashes) properties[`Ashes ${suffix}`] = ashes;

      // ✅ keep "Other" separate
      const otherText = $(`#other_inclusion-${suffix}-text`).val() || '';
      if (otherText.trim() !== '') {
        properties[`Other ${suffix}`] = otherText.trim();
      }

      // ✅ record the birthstone month to its own key
      const bsMonth = $(`#birthstone-select-${suffix}`).val() || '';
      if (bsMonth) {
        properties[`Birthstone ${suffix} Month`] = bsMonth;
      }

      // Engraving
      const engraved = $(`#engraving-select-${suffix}`).val() || '';
      const engravingText = $(`.engraving-text-input[data-slot="${suffix}"]`).val() || '';
      if (engraved) properties[`Engraved ${suffix}`] = engraved;
      if (engraved === 'Custom' && engravingText.trim() !== '') {
        properties[`Engraved Text ${suffix}`] = engravingText;
        chargeEngravingFee = true;
      }
    });

    // Build main product and additional fee line items
    const formData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: properties
        }
      ]
    };

    // Additional Stone Fee
    if (stoneCount > 1) {
      formData.items.push({
        id: 51514594328865,
        quantity: stoneCount - 1,
        properties: {
          linked_to: idProduct,
          label: 'Additional Stones'
        }
      });
    }

    // Extra Inclusions Fee
    if (totalExtraInclusions > 0) {
      formData.items.push({
        id: 51514586890529,
        quantity: totalExtraInclusions,
        properties: {
          linked_to: idProduct,
          label: 'Extra Inclusions'
        }
      });
    }

    // Engraving Fee
    if (chargeEngravingFee) {
      formData.items.push({
        id: 52617873916193,
        quantity: 1,
        properties: {
          linked_to: idProduct,
          label: 'Engraving Fee'
        }
      });
    }

    // Submit via AJAX
    if (valid) {
      $(this).addClass('loading');
      $(this).find('.loading-overlay__spinner').removeClass('hidden');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          const request = new XMLHttpRequest();
          request.addEventListener('load', handleResponse);
          request.open('GET', '?sections=cart-drawer,main-cart-items,cart-icon-bubble', true);
          request.send();
          $('cart-drawer')[0].open();
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          $('cart-drawer').removeClass('is-empty');
          $('.product .my-product-form__submit').removeClass('loading');
          $('.product .my-product-form__submit .loading-overlay__spinner').addClass('hidden');
        });
    }
  });

  $(document).on('click','#CartDrawer-Overlay',function(){
      $('cart-drawer')[0].close();
  });

  // -----------------------------------------------------------------------------
  // Inclusion-type SELECT handler (birthstone, ashes, other)
  // Drives visibility of dependent UI for the current stone suffix.
  // -----------------------------------------------------------------------------
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.inclusion-select')) return;

    const select = e.target;
    const root = select.closest('.inclusions');
    if (!root) return;

    const suffix = String(root.getAttribute('data-inclusions') || '').toUpperCase();
    const chosen = (select.value || '').trim().toLowerCase();

    // Birthstone container in your Liquid:
    // <div class="birthstone-container hidden" data-birthstone-for="A">...</div>
    const birthstoneBlock =
      root.querySelector(`.birthstone-container[data-birthstone-for="${suffix}"]`)
      || root.querySelector(`.birthstone__wrap[data-item="birthstone-${suffix}"]`)
      || root.querySelector(`.select__wrap[data-item="birthstone"][data-suffix="${suffix}"]`);

    // Free Add-Ons block wrapper
    const freeAddonsBlock = root
      .querySelector('.inclusion__contant [data-item="optional"]')
      ?.closest('.inclusion__contant');

    const monthSelect = document.getElementById(`birthstone-select-${suffix}`);

    // Engraving controls
    const engravingBlock  = root.querySelector('.engraving-options-block');
    const engravingSelect = root.querySelector(`#engraving-select-${suffix}`);
    const allowBSEngr = engravingBlock
      ? String(engravingBlock.getAttribute('data-allow-birthstone-engraving') || 'false').toLowerCase() === 'true'
      : false;

    if (!birthstoneBlock) return;

    if (chosen === 'birthstone') {
      // Show Birthstone month and mark required
      birthstoneBlock.classList.remove('hidden');
      birthstoneBlock.style.display = ''; // clear inline hide if any
      if (monthSelect) monthSelect.classList.add('req_input');

      // Hide Free Add-Ons and force "No add on’s"
      if (freeAddonsBlock) {
        freeAddonsBlock.classList.add('hidden');
        freeAddonsBlock.style.display = 'none';
      }
      const optionalWrap = root.querySelector(`.select__wrap[data-item="optional"][data-suffix="${suffix}"]`);
      if (optionalWrap) {
        const allCbs = optionalWrap.querySelectorAll('input[type="checkbox"]');
        const noAdd  = optionalWrap.querySelector('input[type="checkbox"].no-add');
        allCbs.forEach(cb => (cb.checked = false));
        if (noAdd) noAdd.checked = true;
      }

      // Optionally suppress engraving when Birthstone chosen
      if (engravingBlock && engravingSelect && !allowBSEngr) {
        $(engravingSelect).val('None').trigger('change');
        const engravingInput = engravingBlock.querySelector('.engraving-text-input');
        if (engravingInput) {
          engravingInput.value = '';
          const counter = engravingBlock.querySelector(`.engraving-char-count[data-slot="${suffix}"]`);
          if (counter) counter.textContent = `0 / ${engravingInput.getAttribute('maxlength')}`;
        }
        // unlock defaults later
        if (window.manuallyEdited) window.manuallyEdited.delete(suffix);

        engravingSelect.disabled = true;
        engravingBlock.classList.add('hidden');
        engravingBlock.style.display = 'none';
      } else if (engravingBlock && engravingSelect) {
        engravingSelect.disabled = false;
        engravingBlock.classList.remove('hidden');
        engravingBlock.style.display = '';
      }
    } else {
      // Hide Birthstone UI and clear required
      birthstoneBlock.classList.add('hidden');
      birthstoneBlock.style.display = 'none';
      if (monthSelect) {
        monthSelect.classList.remove('req_input');
        monthSelect.value = '';
      }

      // Re-show Free Add-Ons
      if (freeAddonsBlock) {
        freeAddonsBlock.classList.remove('hidden');
        freeAddonsBlock.style.display = '';
      }

      // Re-enable engraving UI
      if (engravingBlock && engravingSelect) {
        engravingSelect.disabled = false;
        engravingBlock.classList.remove('hidden');
        engravingBlock.style.display = '';
        if (window.manuallyEdited) window.manuallyEdited.delete(suffix);
        // keep your existing resetEngravingDefaultForSlot if you want, or omit
        if (typeof resetEngravingDefaultForSlot === 'function') {
          const stoneCount =
            parseInt($('#stone-count-select').val(), 10) ||
            $('.inclusions[data-inclusions]:visible').length || 1;
          resetEngravingDefaultForSlot(suffix, stoneCount);
        }
      }
    }
  });

  // === Marquise birthstone-only enforcement (A & C) ============================
  (function enforceBirthstoneOnly() {
    const section = document.querySelector('section[data-birthstone-mode="only"]');
    if (!section) return; // only run on Marquise

    const positions = (section.getAttribute('data-birthstone-positions') || 'A,C')
      .split(',')
      .map(s => s.trim().toUpperCase())
      .filter(Boolean);

    positions.forEach((suffix) => {
      // 1) Hide Free Add-ons + force "No Addons"
      const optionalWrap = document.querySelector(
        `.select__wrap[data-item="optional"][data-suffix="${suffix}"]`
      );
      if (optionalWrap) {
        optionalWrap.classList.add('hidden');
        optionalWrap.style.display = 'none';
        const noAdd = optionalWrap.querySelector('input[type="checkbox"].no-add');
        const others = optionalWrap.querySelectorAll('input[type="checkbox"]:not(.no-add)');
        others.forEach(cb => (cb.checked = false));
        if (noAdd) noAdd.checked = true;

        // Hide the whole "Free Add-Ons" block (title + message + dropdown)
        const optionalBlock = optionalWrap ? optionalWrap.closest('.inclusion__contant') : null;
        if (optionalBlock) {
          optionalBlock.classList.add('hidden');
          optionalBlock.style.display = 'none';
        }
      }

      // 2) Lock inclusion type to Birthstone
      const sel = document.getElementById(`inclusion-select-${suffix}`);
      if (sel) {
        // set to 'Birthstone' and trigger existing logic
        const birthOpt = Array.from(sel.options).find(
          (o) => (o.value || '').toLowerCase() === 'birthstone'
        );
        if (birthOpt) {
          sel.value = birthOpt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // disable any non-birthstone options
        Array.from(sel.options).forEach((o) => {
          if ((o.value || '').toLowerCase() !== 'birthstone') o.disabled = true;
        });
      }
    });
  })();

  // Show design dropdown for each inclusion__contant that has the flag
  $('.inclusion__contant[data-design-enabled="true"]').each(function(){
    const suffix = String($(this).data('suffix') || '').toUpperCase();
    $(`.select__wrap[data-item="design"][data-suffix="${suffix}"]`).removeClass('hidden');
  });



  // delegate changes for every inclusion group
  document.addEventListener('change', function (e) {
    const labelWrap = e.target.closest('.inclusion__contant[data-design-enabled="true"]');
    if (!labelWrap) return;
    const isOptional = e.target.matches('input[type="checkbox"][name^="optional-"]');
    if (!isOptional) return;
    evaluateGroup(labelWrap);
  });

  // initialize on load
  document.querySelectorAll('.inclusion__contant[data-design-enabled="true"]').forEach(cont => {
    evaluateGroup(cont);
  });

// One-time guard
if (!window.__hmDesignInit) {
  window.__hmDesignInit = true;

  // 1) Reposition design blocks ABOVE engraving blocks for each suffix (A/B)
  $('.inclusions[data-inclusions]').each(function () {
    const suf = String($(this).data('inclusions'));
    const $root = $(this);

    const $design = $root.find(`.select__wrap[data-item="design"][data-suffix="${suf}"]`);
    // Prefer the full engraving options block if present, else the text-only wrap
    const $engraveAnchor = $root.find(`.engraving-options-block, .engraving-text-wrap[data-item="engraving_text_${suf}"]`).first();

    if ($design.length && $engraveAnchor.length) {
      $design.insertBefore($engraveAnchor);
    }

    // Ensure we have a hidden field to capture the value for cart posting
    if ($design.length && !$design.find('input.design-value').length) {
      $design.append(`<input type="hidden" class="design-value" name="design-${suf}" value="">`);
    }
  });

  // 2) Custom-select interactions for the Design picker
  // Open / close
  $(document)
    .off('.hmDesign')
    .on('click.hmDesign', '.custom__select .select__name-wrap', function (e) {
      e.stopPropagation();
      const $custom = $(this).closest('.custom__select');
      $('.custom__select.open').not($custom).removeClass('open');
      $custom.toggleClass('open');
    })

    // Pick an option
    .on('click.hmDesign', '.custom__select .select__option', function (e) {
      e.stopPropagation();

      const $opt = $(this);
      const val = String($opt.attr('value') || '');
      const label = $opt.text().trim();

      const $custom = $opt.closest('.custom__select');
      const $wrap = $opt.closest('.select__wrap[data-item="design"]');
      const $name = $custom.find('.select__name');
      const $hidden = $wrap.find('input.design-value');

      // UI update
      $name.text(label);
      $custom.removeClass('open');
      $wrap.find('.select__option').removeClass('selected');
      $opt.addClass('selected');

      // Store value for cart
      if ($hidden.length) $hidden.val(val);
      // Also mirror to dataset if you read it elsewhere
      $custom[0].dataset.value = val;
    });

  // Close on outside click or Escape
  $(document).on('click.hmDesign', function (e) {
    if (!$(e.target).closest('.custom__select').length) {
      $('.custom__select.open').removeClass('open');
    }
  });
  $(document).on('keydown.hmDesign', function (e) {
    if (e.key === 'Escape') $('.custom__select.open').removeClass('open');
  });

  // 3) Design dropdown display + z-index + overflow fixes
  const style = document.createElement('style');
  style.textContent = `
    /* only style the Design picker */
    .select__wrap[data-item="design"] .custom__select { position: relative; z-index: 5; font: inherit; }
    .select__wrap[data-item="design"] .custom__select .select__name-wrap{
      display:flex; align-items:center; justify-content:space-between;
      padding:12px 16px;
      border:1px solid rgba(255,255,255,.2);
      border-radius:6px;
      background:#121212;
      color:#fff;
      text-transform:uppercase; letter-spacing:.05em; cursor:pointer;
      transition: border-color .2s ease, background .2s ease;
    }
    .select__wrap[data-item="design"] .custom__select .select__name-wrap:hover{
      border-color:#CFA96A; background:rgba(207,169,106,.08);
    }
    .select__wrap[data-item="design"] .custom__select .select__options{
      display:none; position:absolute; top:calc(100% + 6px); left:0; width:100%;
      background:#050B09; color:#AB9D8C;
      border:1px solid rgba(255,255,255,.15); border-radius:6px;
      box-shadow:0 8px 24px rgba(0,0,0,.4);
      z-index:300; max-height:240px; overflow-y:auto; box-sizing:border-box;
    }
    .select__wrap[data-item="design"] .custom__select.open .select__options{ display:block; }
    .select__wrap[data-item="design"] .custom__select .select__option{
      padding:12px 16px; cursor:pointer; text-transform:uppercase; letter-spacing:.05em;
    }
    .select__wrap[data-item="design"] .custom__select .select__option:hover{ background:rgba(255,255,255,.05); color:#CFA96A; }
    .select__wrap[data-item="design"] .custom__select .select__option.selected{ background:rgba(255,255,255,.08); color:#CFA96A; font-weight:600; }

    /* prevent clipping just for the design block */
    .select__wrap[data-item="design"], .select__wrap[data-item="design"] .inclusion__contant{ position:relative; overflow:visible; }
  `;
  document.head.appendChild(style);

}

// OPEN/CLOSE for the Design picker only (won't touch other dropdowns)
$(document)
  .off('click.hmDesignToggle')
  .on('click.hmDesignToggle', '.select__wrap[data-item="design"] .select-item-name', function (e) {
    e.stopPropagation(); // don't bubble to accordion
    const $wrap = $(this).closest('.select__wrap[data-item="design"]');

    // close other dropdowns INSIDE the same inclusions block only
    $wrap.closest('.inclusions')
         .find('.select__wrap .select-checkbox')
         .not($wrap.find('.select-checkbox'))
         .removeClass('active');

    // toggle this one
    $wrap.find('.select-checkbox').toggleClass('active');
  });

  
  // Clicking anywhere else closes the DESIGN dropdown
$(document)
  .off('click.hmDesignOutside')
  .on('click.hmDesignOutside', function (e) {
    if (!$(e.target).closest('.select__wrap[data-item="design"]').length) {
      $('.select__wrap[data-item="design"] .select-checkbox').removeClass('active');
    }
  });

  // ======================================================================
// CLEAN DESIGN REVEAL (A–E dynamic)
// ======================================================================

$(document).off('.hmDesignClean'); // clear any old handlers

$(document).on('change.hmDesignClean', '[data-item="optional"][data-suffix] input[type="checkbox"]', function () {
  const $optWrap = $(this).closest('.select__wrap[data-item="optional"][data-suffix]');
  const suffix = String($optWrap.data('suffix') || '').toUpperCase();
  if (!suffix) return;

  const $checks = $optWrap.find('input[type="checkbox"]');
  const $noAdd = $optWrap.find('input[type="checkbox"].no-add');

  // mutual exclusion with "no add on"
  if ($(this).is($noAdd)) {
    if (this.checked) $checks.not($noAdd).prop('checked', false);
  } else {
    $noAdd.prop('checked', false);
  }

  const anyRealAddon = $checks.filter(':checked').get().some(el => !$(el).is($noAdd));

  const $designWrap = $optWrap
    .closest('.inclusions')
    .find(`.select__wrap[data-item="design"][data-suffix="${suffix}"]`);

  if (!$designWrap.length) {
    console.warn(`Design block missing for suffix ${suffix}`);
    return;
  }

  if (anyRealAddon) {
    $designWrap.removeClass('hidden');
  } else {
    $designWrap.addClass('hidden');
    const $name = $designWrap.find('.select__name');
    const $ph   = $designWrap.find('.select__option[value=""]');
    if ($name.length && $ph.length) $name.text($ph.text().trim());
    $designWrap.find('.select__option').removeClass('selected');
    $designWrap.find('input.design-value').val('');
  }

  console.debug('DesignReveal', { suffix, anyRealAddon, designFound: !!$designWrap.length });
});

// ===== Restore generic faux-dropdown open/close (safe + minimal) =====
$(document)
  .off('click.hmOpenGeneric')
  .on('click.hmOpenGeneric', '.select__wrap .select-item-name', function (e) {
    e.stopPropagation();
    const $wrap = $(this).closest('.select__wrap');
    const $box  = $wrap.find('.select-checkbox');

    // Close other dropdowns in the same inclusions block
    $wrap.closest('.inclusions')
         .find('.select__wrap .select-checkbox')
         .not($box)
         .removeClass('active');

    // Toggle this one
    $box.toggleClass('active');
  });

$(document)
  .off('click.hmOpenOutside')
  .on('click.hmOpenOutside', function (e) {
    if (!$(e.target).closest('.select__wrap .select-checkbox, .select__wrap .select-item-name').length) {
      $('.select__wrap .select-checkbox').removeClass('active');
    }
  });
// --- Emergency CSS to guarantee visibility on "active"
(function(){
  if (!document.getElementById('hm-dd-emergency-css')) {
    const s = document.createElement('style');
    s.id = 'hm-dd-emergency-css';
    s.textContent = `
      .select-checkbox .check-select-items { display: none; }
      .select-checkbox.active .check-select-items { display: block; }
    `;
    document.head.appendChild(s);
  }
})();

// --- Nuke any prior dropdown listeners that might conflict
$(document).off('click.hmOpenAll').off('click.hmCloseAll');

// --- Open/close by toggling .active on the *same* .select-checkbox
$(document).on('click.hmOpenAll', '.select-item-name', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $box = $(this).closest('.select-checkbox');             // e.g. "select-checkbox custom__select"
  const $scope = $(this).closest('.inclusions');                // limit closing to this stone

  // close siblings
  $scope.find('.select-checkbox').not($box).removeClass('active');

  // toggle this one
  $box.toggleClass('active');
});

// --- Close when clicking anywhere else
$(document).on('click.hmCloseAll', function (e) {
  if (!$(e.target).closest('.select-checkbox, .select-item-name').length) {
    $('.select-checkbox').removeClass('active');
  }
});

});